define('viewmodels/app/analytics/__isAnalyticsLoading',[
        'knockout', '../__subrouter',
        'dataSource/analytics/analyticsRegistry'
    ],
    function(ko, router, analyticsRegistry) {
        'use strict';
        var TIME_INTERVAL = 500;
        /**
         * to check whether analytics is loading or not
         * @type {Boolean}
         */
        var isAnalyticsLoading = ko.observable(false);

        // creating computed for loading analytucs
        ko.computed(function() {
            setLoading(!!analyticsRegistry.numLoading() || !!router.isNavigating());
        });

        return isAnalyticsLoading;

        /**
         * function to clear timer to change loading
         * @return {undefined}
         */
        function clearLoadingTimer() {
            if (isAnalyticsLoading.timerID) {
                window.clearTimeout(isAnalyticsLoading.timerID);
                delete isAnalyticsLoading.timerID;
            }
        }

        /**
         * function to update/create loading timer
         * @param  {Boolean} isloading value of loading
         * @return {undefined}
         */
        function updateLoadingTimer(isloading) {
            isAnalyticsLoading(isloading);
            clearLoadingTimer();
        }

        /**
         * function to set new value for loading
         * @param {Boolean} isloading new value of loading
         * @return {undefined}
         */
        function setLoading(isloading) {
            clearLoadingTimer();
            if (isloading !== isAnalyticsLoading.peek()) {
                if(isloading) {
                    updateLoadingTimer(true);
                } else {
                    isAnalyticsLoading.timerID = window.setTimeout(updateLoadingTimer, TIME_INTERVAL, false);
                }
                
            }
        }

    });
